import React from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const InvestorPaymentModal = (props) => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  return (
    <div>
      <Modal
        show={props.paymentModal}
        onHide={() => {
          props.setPaymentModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Enter Payment Amount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            <form
              id="investor-payment-form"
              onSubmit={handleSubmit((value) => {
                console.log(
                  "payment started",
                  props?.policy?.assignments &&
                    props?.policy?.assignments[0].assignmentId
                );
                value.assignmentId =
                  props?.policy?.assignments &&
                  props?.policy?.assignments[0].assignmentId;
                props.setPaymentModal(false);
                navigate("/order/checkout", {
                  state: {
                    value,
                  },
                });
              })}
            >
              <div className="">
                Amount:
                <input
                  className={`${
                    errors.sumOriginalAmount ? "is-invalid" : ""
                  } form-control`}
                  aria-invalid={!!errors.sumOriginalAmount}
                  id="sumOriginalAmount"
                  {...register("sumOriginalAmount", {
                    required: "Amount is required",
                    pattern: {
                      value: /^[1-9]\d*$/,
                      message: "Please enter a valid integer greater than 0",
                    },
                  })}
                  type="text"
                />
                <div className="invalid-feedback">
                  {errors?.sumOriginalAmount?.message}
                </div>
              </div>
            </form>
          }
        </Modal.Body>
        <Modal.Footer>
          <button
            className="normal-button px-3 py-2 "
            form="investor-payment-form"
            type="submit"
          >
            Submit
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default InvestorPaymentModal;
